import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const LiteratureReviewIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.64052 1.47375H5.27365V16.7276H1.64052V1.47375Z"
        fill="var(--cdl-chart-yellow-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833328 1.47381C0.833328 1.02802 1.19472 0.666626 1.64051 0.666626H5.27364C5.71944 0.666626 6.08083 1.02802 6.08083 1.47381V16.7277C6.08083 17.1735 5.71944 17.5349 5.27364 17.5349H1.64051C1.19472 17.5349 0.833328 17.1735 0.833328 16.7277V1.47381ZM2.4477 2.281V15.9205H4.46646V2.281H2.4477Z"
        fill="var(--cdl-chart-yellow-base)"
      />
      <path
        d="M13.9496 3.37646L15.9179 3.03538L18.2335 16.3978L16.2652 16.7389L13.9496 3.37646Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1543 3.51421C13.0782 3.07495 13.3725 2.65717 13.8118 2.58105L15.7801 2.23996C16.2193 2.16384 16.6371 2.45822 16.7132 2.89747L19.0288 16.2599C19.1049 16.6992 18.8106 17.117 18.3713 17.1931L16.403 17.5342C15.9638 17.6103 15.546 17.3159 15.4699 16.8767L13.1543 3.51421ZM14.8828 4.03389L16.9227 15.8057L17.3003 15.7403L15.2604 3.96845L14.8828 4.03389Z"
        fill="currentColor"
      />
      <path
        d="M8.0313 7.4231H11.9958V16.7276H8.0313V7.4231Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.22411 7.42315C7.22411 6.97736 7.5855 6.61597 8.03129 6.61597H11.9958C12.4416 6.61597 12.803 6.97736 12.803 7.42315V16.7277C12.803 17.1735 12.4416 17.5349 11.9958 17.5349H8.03129C7.5855 17.5349 7.22411 17.1735 7.22411 16.7277V7.42315ZM8.83848 8.23034V15.9205H11.1886V8.23034H8.83848Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LiteratureReviewIcon;
